import ServiceProvider from "../models/serviceProvider";
import WorkOrder from "../models/workOrder";
import WorkOrderFilters from "../models/workOrderFilters";
import httpService from "./httpService";
import File from "../models/file";

const apiEndpoint = "/workOrders";

const getWorkOrders = (
  idSubscription: number,
  workOderFilters: WorkOrderFilters,
) => {
  return httpService.post<WorkOrder[]>(
    `${apiEndpoint}/getWorkOrders?idSubscription=${idSubscription}`,
    workOderFilters,
  );
};

const getWorkOrderByNumber = (
  idSubscription: number,
  workOrderNumber: string,
) => {
  return httpService.get<WorkOrder | undefined>(
    `${apiEndpoint}/getWorkOrderByNumber?idSubscription=${idSubscription}&workOrderNumber=${workOrderNumber}`,
  );
};

const createWorkOrder = (idSubscription: number, workOrder: WorkOrder) => {
  return httpService.post<WorkOrder>(
    `${apiEndpoint}/createWorkOrder?idSubscription=${idSubscription}`,
    workOrder,
  );
};

const dispatchWorkOrder = (
  idSubscription: number,
  workOrder: WorkOrder,
  serviceProviders: ServiceProvider[],
  files: File[],
) => {
  return httpService.post(
    `${apiEndpoint}/dispatchWorkOrder?idSubscription=${idSubscription}`,
    {
      workOrder,
      serviceProviders,
      files,
    },
  );
};

const acceptWorkOrder = (idSubscription: number, workOrderNumber: string) => {
  return httpService.post(
    `${apiEndpoint}/acceptWorkOrder?idSubscription=${idSubscription}&workOrderNumber=${workOrderNumber}`,
  );
};

const declineWorkOrder = (
  idSubscription: number,
  workOrderNumber: string,
  declineReason: string | undefined,
) => {
  return httpService.post(
    `${apiEndpoint}/declineWorkOrder?idSubscription=${idSubscription}&workOrderNumber=${workOrderNumber}`,
    {
      declineReason,
    },
  );
};

const scheduleWorkOrder = (
  idSubscription: number,
  workOrderNumber: string,
  scheduledDate: Date,
) => {
  return httpService.post(
    `${apiEndpoint}/scheduleWorkOrder?idSubscription=${idSubscription}&workOrderNumber=${workOrderNumber}`,
    {
      scheduledDate,
    },
  );
};

const getWorkOrderFiles = (idSubscription: number, workOrderNumber: string) => {
  return httpService.get<File[]>(
    `${apiEndpoint}/getWorkOrderFiles?idSubscription=${idSubscription}&workOrderNumber=${workOrderNumber}`,
  );
};

const deleteWorkOrderFile = (
  idSubscription: number,
  workOrderNumber: string,
  fileResourceId: string,
) => {
  return httpService.post(
    `${apiEndpoint}/deleteWorkOrderFile?idSubscription=${idSubscription}&workOrderNumber=${workOrderNumber}&fileResourceId=${fileResourceId}`,
  );
};

const shareWorkOrderFiles = (
  idSubscription: number,
  isShareAction: boolean,
  fileResourceIds: string[],
  fromWorkOrderNumber: string,
  toWorkOrderNumbers: string[],
) => {
  return httpService.post(
    `${apiEndpoint}/shareWorkOrderFiles?idSubscription=${idSubscription}`,
    {
      isShareAction,
      fileResourceIds,
      fromWorkOrderNumber,
      toWorkOrderNumbers,
    },
  );
};

const workOrderService = {
  getWorkOrders,
  getWorkOrderByNumber,
  createWorkOrder,
  dispatchWorkOrder,
  acceptWorkOrder,
  declineWorkOrder,
  scheduleWorkOrder,
  getWorkOrderFiles,
  deleteWorkOrderFile,
  shareWorkOrderFiles,
};

export default workOrderService;
